import React from "react";
import Layout from "@/Layout";
import { Input, Radio, message, Spin, Select, Modal } from "antd";
import { get, put } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import Router from "next/router";
import { getStaticPropsFromStrapiSEOSetting } from "$DATA/seo";

export async function getStaticProps() {
	return await getStaticPropsFromStrapiSEOSetting('/me/self-exclusion'); //參數帶本頁的路徑
}

const { Option } = Select;

const _number = /[^\d]/g;

export default class Selfexclusion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 1,
            RadioStatusset: [], //选择限制天数
            loading: false,
            BetLimit: "",
            limitAmountInputIsEnable: false,
            // 點擊確定 提交後該確定紐會隱藏
            SubmitIsDisabled: false,
            initialCheck: true,
        };
    }
    componentDidMount() {
        let teststatus = !localStorage.getItem("access_token");
        if (teststatus) {
            Router.push("/");
            setTimeout(() => {
                global.goUserSign("1");
            }, 500);
            return;
        }
        this.SelfExclusions();
    }

    ChangeStatus(type, e) {
        if (e) {
            if (type === "Radio") {
                this.setState({
                    RadioStatusset: e,
                });
            } else if (type === "Number") {
                this.setState({
                    BetLimit: e.target.value.replace(_number, ""),
                });
            }
        }
    }

    SelfExclusions() {
        get(ApiPort.GETSelfExclusions).then((res) => {
            if (res && res.result) {
                const {
                    betLimit,
                    betLimitDayRange,
                    selfExcludeDuration,
                    status,
                } = res.result;
                if (!status) {
                    return;
                }
                /* 
                    === betLimitDayRange ===
                    0: 未設置
                    1: 1天
                    7: 7天
                    -1 || 99999: 永久
                    === betLimit ===
                    有設置天數狀態下，betLimit回傳999999
                */
                const normalizedDayRange = betLimitDayRange === 99999 ? -1 : betLimitDayRange;
                if (normalizedDayRange === 0) {
                    // Check for limited amount
                    this.setState({
                        BetLimit: betLimit,
                        SubmitIsDisabled: betLimit ? true : false,
                        limitAmountInputIsEnable: betLimit ? true : false,
                        initialCheck: false,
                    });
                } else {
                    // Check for login exclusion
                    this.setState({
                        RadioStatusset: normalizedDayRange,
                        SubmitIsDisabled: true,
                        initialCheck: false,
                    });
                }
            }
        });
    }

    SetSelfExclusions() {
        const { RadioStatusset, BetLimit } = this.state;
        let setting;
        if (Array.isArray(RadioStatusset)) {
            //选择限制天数
            setting = "NotAvailable";
        } else if (RadioStatusset == "7") {
            setting = "SevenDays";
        } else if (RadioStatusset == "90") {
            setting = "NinetyDays";
        } else if (RadioStatusset == "-1") {
            setting = "Permanent";
        }

        this.setState({
            loading: true,
        });
        const MemberData = {
            setting: setting,
            isEnabled: true,
            limitAmount: parseInt(BetLimit),
            //选择限制天数
            betLimitDayRange: !Array.isArray(RadioStatusset)
                ? RadioStatusset
                : "0",
        };

        put(ApiPort.PUTSelfExclusions, MemberData).then((res) => {
            this.setState({
                loading: false,
            });
            if (res && res.isSuccess) {
                message.success("ตั้งค่าสำเร็จ", 3); //设置成功
                // 點擊確定 提交後該確定紐會隱藏 待時間到或是客服手動解開才能再次設置
                this.setState({
                    SubmitIsDisabled: true,
                });
                this.SelfExclusions();
            } else {
                message.error("การตั้งค่าล้มเหลว", 3); //设置失败！
            }
        });
    }

    render() {
        const { BetLimit, RadioStatusset } = this.state;
        const SubmitBtnIsabled =
            BetLimit !== "" || !Array.isArray(RadioStatusset);
        return (
            <Layout
                seoData={this.props.seoData}
                status={1}
            >
                <Spin spinning={this.state.loading} tip="โปรดรอ...">
                    {/* 请稍后... */}
                    <div className="common-distance-wrap">
                        <div className="common-distance Selfexclusion-content">
                            <div className="txtbox">
                                <br />
                                <p>
                                    Fun88
                                    เข้าใจและทราบถึงความสำคัญในการจำกัดและควบคุมปัญหาการเดิมพัน
                                    ออนไลน์อย่างมีประสิทธิภาพด้วยเหตุนี้
                                    เราได้ทำการติดตั้งเครื่องมือสำหรับ
                                    การตั้งค่าควบคุมวงเงินของสมาชิกที่จะใช้ในการเดิมพัน
                                    สมาชิกสามารถตั้งค่า
                                    วงเงินเดิมพันสำหรับเกมส์การเดิมพันกีฬาและยังสามารถปรับเปลี่ยนยอดวงเงิน
                                    จำกัดและเลือกระยะเวลาการจำกัดตัวเองทั้งสามแบบ
                                    ตามที่สมาชิกต้องการ
                                </p>
                            </div>
                            <div className="form-submit">
                                <div className="l">
                                    <label>
                                        <input
                                            type="radio"
                                            checked={
                                                this.state
                                                    .limitAmountInputIsEnable
                                            }
                                            onChange={() => {
                                                this.setState({
                                                    limitAmountInputIsEnable: true,
                                                    initialCheck: false,
                                                });

                                                if (
                                                    !this.state.SubmitIsDisabled
                                                ) {
                                                    this.setState({
                                                        RadioStatusset: [], //选择限制天数
                                                    });
                                                }
                                            }}
                                        />
                                        จำกัดวงเงินการโอน
                                        {/* 转账总额限制 */}
                                    </label>
                                    <Input
                                        maxLength={6}
                                        placeholder="ระบุวงเงินที่ต้องการจำกัดการโอน" //输入转账总额限
                                        value={this.state.BetLimit}
                                        onChange={(e) =>
                                            this.ChangeStatus("Number", e)
                                        }
                                        style={{ width: 316, height: 45 }}
                                        onFocus={() => {
                                            this.setState({
                                                limitAmountInputIsEnable: true,
                                                initialCheck: false,
                                            });
                                        }}
                                        disabled={
                                            this.state.SubmitIsDisabled
                                                ? true
                                                : this.state.initialCheck
                                                ? false
                                                : this.state
                                                      .limitAmountInputIsEnable
                                                ? false
                                                : true
                                        }
                                    />
                                    <span
                                        className="red"
                                        style={
                                            !this.state
                                                .limitAmountInputIsEnable &&
                                            !this.state.initialCheck
                                                ? { color: "#BCBEC3" }
                                                : {}
                                        }
                                    >
                                        หมายเหตุ: จำนวนเงินโอนทั้งหมดของคุณภายใน
                                        7 วัน จะขึ้นอยู่กับ จำนวนเงินที่คุณกรอก
                                        {/* 注：7
                                        天内您的转账总额将以您填入的数目为准。 */}
                                    </span>
                                </div>
                                <div className="c">
                                    <label>
                                        <input
                                            type="radio"
                                            checked={
                                                this.state.initialCheck
                                                    ? false
                                                    : !this.state
                                                          .limitAmountInputIsEnable
                                            }
                                            onChange={() => {
                                                this.setState({
                                                    limitAmountInputIsEnable: false,
                                                    initialCheck: false,
                                                });

                                                if (
                                                    !this.state.SubmitIsDisabled
                                                ) {
                                                    this.setState({
                                                        BetLimit: "",
                                                    });
                                                }
                                            }}
                                        />
                                        ข้อจำกัดในการเข้าสู่ระบบ
                                        {/* 登入限制 */}
                                    </label>
                                    <Select
                                        className="selfExclusion-selectDays"
                                        suffixIcon={
                                            <img src="/th/img/selfexclusion/icon.svg" />
                                        }
                                        style={{ width: 316 }}
                                        placeholder="เลือกวันที่จะจำกัด" //选择限制天数
                                        value={this.state.RadioStatusset}
                                        dropdownClassName="selfExclusion-selectDays-dropdown"
                                        dropdownStyle={{ borderRadius: 8 }}
                                        dropdownMenuStyle={{
                                            padding: 0,
                                            borderRadius: 8,
                                        }}
                                        disabled={
                                            this.state.SubmitIsDisabled
                                                ? true
                                                : this.state.initialCheck
                                                ? false
                                                : this.state
                                                      .limitAmountInputIsEnable
                                                ? true
                                                : false
                                        }
                                        onFocus={() => {
                                            this.setState({
                                                initialCheck: false,
                                                limitAmountInputIsEnable: false,
                                            });
                                        }}
                                        onChange={(e) => {
                                            this.ChangeStatus("Radio", e);
                                        }}
                                    >
                                        <Option value={7}>
                                            ตั้งข้อจำกัดของตัวเองช่วง 7 วัน
                                            {/* 7 天内无法进行存款、转账及游戏 */}
                                        </Option>
                                        <Option value={90}>
                                            ตั้งข้อจำกัดของตัวเองช่วง 90 วัน
                                            {/* 90 天内无法进行存款、转账及游戏 */}
                                        </Option>
                                        <Option value={-1}>
                                            ตั้งข้อจำกัดของตัวเองแบบถาวร
                                            {/* 永远 */}
                                        </Option>
                                    </Select>
                                    <span
                                        className="red"
                                        style={
                                            this.state
                                                .limitAmountInputIsEnable &&
                                            !this.state.initialCheck
                                                ? { color: "#BCBEC3" }
                                                : {}
                                        }
                                    >
                                        หลังจากตั้งค่าแล้ว
                                        คุณจะไม่สามารถทำการฝาก โอน และเล่นเกมได้
                                        ภายในระยะเวลาที่คุณเลือก
                                        {/* 开启之后您将在选择日期内无法进行存款、转账及游戏。 */}
                                    </span>
                                </div>

                                <div className="r">
                                    <button
                                        disabled={!SubmitBtnIsabled}
                                        onClick={() => {
                                            this.SetSelfExclusions();
                                        }}
                                        style={{
                                            display: this.state.SubmitIsDisabled
                                                ? "none"
                                                : "block",
                                        }}
                                    >
                                        ยืนยัน
                                        {/* 确定 */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Spin>
            </Layout>
        );
    }
}
